<template>
  <b-row class="auth row vh-100 text-center">
    <b-col class="col-12 my-auto">
      <router-view></router-view>
    </b-col>
  </b-row>
</template>
<script>
export default {};
</script>
<style>
.auth {
  margin-left: 0;
  margin-right: 0;
}

.auth-logo {
  margin-top: -88px;
  margin-bottom: 30px;
}

.auth-logo img {
  width: 80px;
}

.card {
  box-shadow: 0 0 5rem 0 rgba(136, 152, 170, 0.3);
}
</style>
